<template>
  <canvas :id="id" class="chart-canvas" :height="height"></canvas>
</template>

<script>
import Chart from "chart.js/auto";

// Pineapple 톤 컬러 팔레트 (데이터셋 순서대로 매핑)
const P_COLORS = [
  "#C98A0A", // point-deep (메인 — 카멜 옐로)
  "#1A1612", // ink (보조 — 다크)
  "#2F8F4F", // ok (3번째 — 그린)
];
const P_GRID = "#E6DCC4";  // p-line
const P_TICK = "#9C9486";  // p-ink-soft

export default {
  name: "DefaultLineChart",
  props: {
    id: { type: String, default: "chart-line" },
    height: { type: String, default: "300" },
    chart: {
      type: Object,
      required: true,
      labels: Array,
      datasets: { type: Array, label: String, data: Array },
    },
  },
  mounted() {
    const ctx = document.getElementById(this.id).getContext("2d");

    // 노란 그라디언트 영역 채우기 (위→아래 페이드)
    const gradient = ctx.createLinearGradient(0, 0, 0, 280);
    gradient.addColorStop(0, "rgba(255, 201, 60, 0.20)");
    gradient.addColorStop(0.5, "rgba(255, 201, 60, 0.05)");
    gradient.addColorStop(1, "rgba(255, 201, 60, 0)");

    // 기존 인스턴스 destroy
    const existing = Chart.getChart(this.id);
    if (existing) existing.destroy();

    const datasets = (this.chart.datasets || []).map((ds, i) => {
      const color = P_COLORS[i % P_COLORS.length];
      return {
        label: ds.label,
        tension: 0.4,
        borderWidth: 3,
        pointRadius: 3,
        pointBackgroundColor: color,
        pointBorderColor: color,
        pointHoverRadius: 5,
        pointHoverBorderWidth: 2,
        pointHoverBackgroundColor: "#FFFBEF",
        pointHoverBorderColor: color,
        borderColor: color,
        // 첫 번째 데이터셋만 영역 그라디언트 채우기 (다른 데이터셋은 라인만)
        backgroundColor: i === 0 ? gradient : "transparent",
        fill: i === 0,
        data: ds.data,
      };
    });

    new Chart(ctx, {
      type: "line",
      data: { labels: this.chart.labels, datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: "#1A1612",
            titleColor: "#FFC93C",
            bodyColor: "#FFFBEF",
            padding: 10,
            cornerRadius: 8,
            displayColors: true,
            usePointStyle: true,
            titleFont: { weight: "800", size: 12 },
            bodyFont: { weight: "600", size: 12 },
          },
        },
        interaction: { intersect: false, mode: "index" },
        scales: {
          y: {
            grid: {
              drawBorder: false,
              display: true,
              drawOnChartArea: true,
              drawTicks: false,
              color: P_GRID,
              borderDash: [4, 4],
            },
            ticks: {
              display: true,
              padding: 10,
              color: P_TICK,
              font: { family: "Pretendard, sans-serif", weight: "600", size: 11 },
            },
          },
          x: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              display: true,
              color: P_TICK,
              padding: 10,
              font: { family: "Pretendard, sans-serif", weight: "600", size: 11 },
            },
          },
        },
      },
    });
  },
};
</script>
